/**
 * 根据动态路由名称，自定义商家id与产地id
 * 需要和小程序端对应
 */
export default {
  //河北衡水市饶阳
  chandiguanli: {
    merchant: 120236,
    produce: 1393
  },
  //广东湛江市廉江
  lianjiangnong: {
    merchant: 360322513626183,
    produce: 2175
  },
  //广东肇庆市德庆
  deqinggonggan: {
    merchant: 9584058,
    produce: 2189
  },
  //广东广州市白云区
  baiyunnong: {
    merchant: 880719438626146,
    produce: 2124
  },
  //广东湛江市麻章区
  MaZhengFuGuiZhuYunShangHuaShi: {
    merchant: 8481953,
    produce: 2172
  },
  //大湾区（肇庆高要）预制菜线上产业园
  gaoyaoyuzhicaichanyeyuan: {
    merchant: 302950460795108,
    produce: 2190
  },
  // 化橘红
  huajuhongbao: {
    merchant: 9729469,
    produce: 2182
  },
  // 徐闻好物集
  xuwenhaowuji: {
    merchant: 323477346386123,
    produce: 2174
  },
  //县域008
  yuenongbo: {
    merchant: 520354808446160,
    produce: 20
  },
  //黄芪县
  hengshanhuangqixianshangjiaoyihui: {
    merchant: 862691349906124,
    produce: 135
  },
  //郁南县
  yunongbang: {
    merchant: 645670191846186,
    produce: 2293
  },
  //惠来县
  huilaiwubao: {
    merchant: 7229714,
    produce: 2289
  },
  //乐昌
  lenongyoupin: {
    merchant: 483796292795112,
    produce: 2140
  },
  //遥田集
  yaotianji: {
    merchant: 465787626526163,
    produce: 2139
  },
  //保供稳价安心数字平台
  baogongwenjiaanxinshuzipingtai: {
    merchant: 160726,
    produce: 2123
  },
  //珠海农产品稳产保供数字营销平台
  zhuhainongyou: {
    merchant: 282923075206137,
    produce: 322
  }
}
